export default __webpack_public_path__ + "static/media/hero programacion 2026.06896cb5.jpg";